import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import loadPerformanceWidgetFrequencies from "@tecumseh/Handlers/PerformanceFreqData";
import { Fluide, LocalizationEnum, PerformanceWidgetInfo } from "@tecumseh/Services/PerformanceWidgetService";
import { CustomApiHandler, CustomHandler } from "@tecumseh/Store/CustomHandlerCreator/CustomHandlerCreator";

type WidgetRefrigerantHandlerType = CustomHandler<{
    widgetInfo: PerformanceWidgetInfo;
    currentFluide: Fluide;
    lang: string;
    selectedRefrigerant: string;
}>;

export const SelectRefrigerant: WidgetRefrigerantHandlerType = props => {
    const {
        widgetInfo: { productType, fluides, textes, applicationID, globalModel },
        currentFluide,
    } = props.parameter;

    const fluide = currentFluide && currentFluide.refrigerant ? currentFluide.refrigerant : "";
    const mid = currentFluide?.def_Cond?.toLowerCase() === "mid";

    props.dispatch({
        type: "Custom/WidgetInfo/SetSelectedFluid",
        selectedFluid: fluide,
    });

    if (fluide === textes[LocalizationEnum.REFRIGERANT_CHOOSE]) {
        props.dispatch({
            type: "Custom/WidgetInfo/SetSelectedFreq",
            selectedFreq: textes[LocalizationEnum.REFRIGERANT_FIRST],
        });
    }

    props.dispatch(
        loadPerformanceWidgetFrequencies({
            type: productType,
            model: globalModel,
            lang: props.parameter.lang,
            fluide,
            applicationId: applicationID,
            mid,
        }),
    );
};

export const chain = [SelectRefrigerant];

const selectPerformanceRefrigerant = createHandlerChainRunner(chain, "SelectPerformanceRefrigerant");

export default selectPerformanceRefrigerant;
